"use strict";

var _interopRequireDefault = require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _TxMap = _interopRequireDefault(require("@/components/TxMap"));
var _region = require("@/api/region");
var _config = require("@/api/config");
var _pos = require("@/api/pos");
var _vuex = require("vuex");
var _objectSpread2;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _default = {
  components: {
    TxMap: _TxMap.default
  },
  data: function data() {
    return {
      createVisible: false,
      joinVisible: false,
      form: {
        title: '',
        contact: '',
        mobile: '',
        region_id: '',
        location: '',
        longitude: '',
        latitude: ''
      },
      invite_code: '',
      regionTree: [],
      loading: false,
      createRules: {
        title: [{
          required: true,
          message: '请输入门店名称',
          trigger: 'change'
        }],
        contact: [{
          required: true,
          message: '请输入联系姓名',
          trigger: 'change'
        }],
        mobile: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'change'
        }],
        region_id: [{
          required: true,
          message: '请选择所在地区',
          trigger: 'change'
        }],
        location: [{
          required: true,
          message: '请输入详细地址',
          trigger: 'change'
        }]
      },
      firm: {},
      owner: []
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user'])),
  created: function created() {
    var _this = this;
    (0, _config.getInfo)({
      app: 'firm'
    }).then(function (res) {
      _this.firm = res.data;
    });
    (0, _pos.getOwner)().then(function (res) {
      _this.owner = res.data;
    });
    (0, _region.getTree)({
      level: 2
    }).then(function (res) {
      _this.regionTree = res.data;
    });
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)({
    logout: 'user/logout',
    getState: 'user/getState'
  })), {}, (_objectSpread2 = {
    handleCreate: function () {
      var _handleCreate = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.$refs.form.validate(function (valid) {
                if (valid) {
                  // 判断有没有选择地址
                  // if (!this.form.latitude || !this.form.longitude) {
                  //   return this.$message.error('请进行门店定位，定位后可改写详细地址')
                  // }
                  _this2.loading = true;
                  if (_this2.form.region_id && Array.isArray(_this2.form.region_id)) {
                    _this2.form.region_id = _this2.form.region_id[_this2.form.region_id.length - 1];
                  }
                  (0, _pos.register)(_objectSpread({}, _this2.form)).then(function (res) {
                    if (!res.code && res.data) {
                      _this2.handleLogin(res.data.id);
                    } else {
                      _this2.$message.error(res.msg);
                    }
                  }).finally(function () {
                    _this2.loading = false;
                  });
                }
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleCreate() {
        return _handleCreate.apply(this, arguments);
      }
      return handleCreate;
    }(),
    handleLogin: function () {
      var _handleLogin = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var _yield$login, code, msg;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.loading = true;
              _context2.next = 3;
              return (0, _pos.login)({
                id: id
              });
            case 3:
              _yield$login = _context2.sent;
              code = _yield$login.code;
              msg = _yield$login.msg;
              if (!code) {
                window.location.href = '/web';
              } else {
                this.$message.error(msg);
              }
              this.loading = false;
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleLogin(_x) {
        return _handleLogin.apply(this, arguments);
      }
      return handleLogin;
    }(),
    handleLogout: function () {
      var _handleLogout = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.logout();
            case 2:
              this.$router.push("/?redirect=".concat(this.$route.fullPath));
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleLogout() {
        return _handleLogout.apply(this, arguments);
      }
      return handleLogout;
    }(),
    handleJoin: function () {
      var _handleJoin = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this3 = this;
        var _yield$join, code, msg, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0, _pos.join)({
                invite_code: this.invite_code
              });
            case 2:
              _yield$join = _context4.sent;
              code = _yield$join.code;
              msg = _yield$join.msg;
              data = _yield$join.data;
              if (!code) {
                this.$notify({
                  title: '已成功加入门店',
                  message: '待门店管理员分配角色权限后即可使用',
                  duration: 0
                });
                setTimeout(function () {
                  _this3.handleLogin(data.id);
                }, 3000);
              } else {
                this.$message.error(msg);
              }
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleJoin() {
        return _handleJoin.apply(this, arguments);
      }
      return handleJoin;
    }(),
    handleQuit: function () {
      var _handleQuit = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
        var _this4 = this;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.$confirm('该操作会将您从该门店团队中移除，请确认是否退出', '提示').then(function (res) {
                if (res === 'confirm') {
                  (0, _pos.quit)({
                    id: id
                  }).then(function (result) {
                    if (!result.code) {
                      _this4.getOwner();
                    } else {
                      _this4.$message.error(res.msg);
                    }
                  });
                }
              });
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleQuit(_x2) {
        return _handleQuit.apply(this, arguments);
      }
      return handleQuit;
    }()
  }, (0, _defineProperty2.default)(_objectSpread2, "handleLogout", function () {
    var _handleLogout2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return this.logout();
          case 2:
            this.$router.push("/?redirect=".concat(this.$route.fullPath));
          case 3:
          case "end":
            return _context6.stop();
        }
      }, _callee6, this);
    }));
    function handleLogout() {
      return _handleLogout2.apply(this, arguments);
    }
    return handleLogout;
  }()), (0, _defineProperty2.default)(_objectSpread2, "regionChange", function regionChange(val) {
    if (val.length) {
      this.form.region_id = val[val.length - 1];
    } else {
      this.form.region_id = '';
    }
  }), (0, _defineProperty2.default)(_objectSpread2, "locationChange", function locationChange(data) {
    for (var k in this.form) {
      this.form[k] = data[k];
    }
  }), _objectSpread2))
};
exports.default = _default;